import React from 'react';

import Main from '../../Main';

/**
 * Kiosk layout — a signed-in page that is shown to a CUSTOMER, not to staff.
 *
 * Same shell as the public layout (theme + auth context, no menu, no header, no
 * breadcrumb), but deliberately NOT registered as a public route: the pages under
 * /kiosk call authenticated endpoints so the API can record which staff member
 * vouched for what was captured. An unauthenticated visit must bounce to login
 * exactly like any other internal route — see layouts/index.js, where /kiosk is
 * absent from the list that tolerates a missing session.
 *
 * Nothing internal may be rendered inside this layout. No queue, no counts, no
 * colleague names, no "pending review" wording. Someone else's customer is holding
 * the device.
 */
const KioskLayout = ({ children }) => (
    <Main>
        {children}
    </Main>
);

export default KioskLayout;
